import React from 'react';
import { Modal, Button } from 'antd';
import styles from './AdminModalV2.module.scss';

export default function AdminModalV2({
  visible,
  title,
  eyebrow,
  description,
  children,
  onCancel,
  onSubmit,
  submitText = 'Save',
  cancelText = 'Cancel',
  confirmLoading = false,
  width = 680,
  destroyOnClose = true,
  maskClosable = true,
  keyboard = true,
  okButtonProps = {},
  cancelButtonProps = {},
  modalProps = {},
}) {
  return (
    <Modal
      visible={visible}
      title={null}
      footer={null}
      onCancel={onCancel}
      destroyOnClose={destroyOnClose}
      width={width}
      maskClosable={maskClosable}
      keyboard={keyboard}
      wrapClassName={styles.wrap}
      className={styles.modal}
      {...modalProps}
    >
      <div className={styles.body}>
        <div className={styles.header}>
          {eyebrow ? <div className={styles.eyebrow}>{eyebrow}</div> : null}
          {title ? <h2 className={styles.title}>{title}</h2> : null}
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>

        <div className={styles.content}>
          {children}
        </div>

        <div className={styles.footer}>
          <Button
            className={styles.cancelButton}
            onClick={onCancel}
            {...cancelButtonProps}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            className={styles.submitButton}
            loading={confirmLoading}
            onClick={onSubmit}
            {...okButtonProps}
          >
            {submitText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
